module.exports = __webpack_public_path__ + "img/sound-4-image.a5b041a4.jpg";